
import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'typesafe-actions';
import { closeDisplays } from '../state/uiControl/uiControl.actions';
import { Display } from '../state/uiControl/uiControl.reducer';
import { ShipInfo } from './ShipInfo';
import SwipeableDrawer from './SwipeableDrawer';
import { useIsMobile } from '../hooks';

export const ShipDrawer = ({
  closeDisplays,
  selected,
  showing
}: ShipDrawerProps
) => {
  const isMobile = useIsMobile();

  return (
    <SwipeableDrawer
      open={isMobile && showing} 
      onClose={closeDisplays}
    >
      <ShipInfo inDrawer selectedShip={selected} />
    </SwipeableDrawer>
  );
};

const mapStateToProps = (state: RootState) => ({
  selected: state.uiControl.selectedShip,
  showing: state.uiControl.showing === Display.SHIP,
});

const dispatchProps = {
  closeDisplays,
};

type ShipDrawerProps = ReturnType<typeof mapStateToProps> & typeof dispatchProps;

export default connect(
  mapStateToProps,
  dispatchProps
)(ShipDrawer);